//@ts-check

class ApprovalDocumentsDataService {
	constructor($http, Utility, $timeout, $rootScope, ContentService, LocalStorageService, InternalLinksService) {
		this.$http = $http;
		this.Utility = Utility;
		this.$timeout = $timeout;
		this.$rootScope = $rootScope;
		this.ContentService = ContentService;
		this.LocalStorageService = LocalStorageService;
		this.InternalLinksService = InternalLinksService;

		this.init();
	}

	init() {
		this.documentsData = null;
		this.InternalLinksService.getLinks('/api/documents/links');
	}

	async getDocumentApprovals(schemeRef) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			let url = await this.InternalLinksService.getLink('GetDocumentApprovals');
			if (!url) {
				await this.InternalLinksService.getLinks('/api/documents/links');
				url = await this.InternalLinksService.getLink('GetDocumentApprovals');
			}

			if (!schemeRef) {
				throw new Error('No Building reference provided...');
			}

			const headers = this.Utility.headersWithContentType;
			url = url.replace('{schemeRef}', schemeRef).trim();

			const results = await this.$http.get(url, { headers });
			const approvalsData = results.data ? results.data : results;
			this.approvalsData = approvalsData;

			this.$timeout(() => promiseHandler.resolve(approvalsData));
		} catch (error) {
			const approvalsData = '';
			this.$timeout(() => promiseHandler.reject(error));
		}

		return promise;
	}

	async approveDocument(approvalId, schemeRef) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			let url = await this.InternalLinksService.getLink('ApproveDocument');
			if (!url) {
				await this.InternalLinksService.getLinks('/api/documents/links');
				url = await this.InternalLinksService.getLink('ApproveDocument');
			}

			if (!approvalId) {
				throw new Error('No approval id provided...');
			}

			if (!schemeRef) {
				throw new Error('No Building reference provided...');
			}
			url = url.replace('{schemeRef}', schemeRef).trim();
			url = url.replace('{approvalId}', approvalId).trim();

			const results = await this.$http.post(url);
			const { data } = results;
			await this.getDocumentApprovals(schemeRef);

			this.$timeout(() => promiseHandler.resolve(data));
		} catch (error) {
			const approvalsData = '';
			this.$timeout(() => promiseHandler.reject(error));
		}

		return promise;
	}

	async rejectDocument(approvalId, schemeRef) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			if (!approvalId) {
				throw new Error('No approval id provided...');
			}
			if (!schemeRef) {
				throw new Error('No Building reference provided...');
			}

			let url = await this.InternalLinksService.getLink('RejectDocument');

			if (!url) {
				await this.InternalLinksService.getLinks('/api/payments/links');
				url = await this.InternalLinksService.getLink('RejectDocument');
			}
			url = url.replace('{schemeRef}', schemeRef).trim();
			url = url.replace('{approvalId}', approvalId).trim();
			const results = await this.$http.post(url);
			const { data } = results;
			await this.getDocumentApprovals(schemeRef);

			this.$timeout(() => promiseHandler.resolve(data));
		} catch (err) {
			this.$timeout(() => promiseHandler.reject(err));
		}

		return promise;
	}

	async queryDocument(approvalId, message, schemeRef) {
		let promise, promiseHandler;

		try {
			promise = new Promise((resolve, reject) => {
				promiseHandler = {
					reject,
					resolve
				};
			});

			let url = await this.InternalLinksService.getLink('QueryDocument');
			if (!url) {
				await this.InternalLinksService.getLinks('/api/documents/links');
				url = await this.InternalLinksService.getLink('QueryDocument');
			}

			if (!approvalId) {
				throw new Error('No approval id provided...');
			}

			if (!message) {
				throw new Error('No Query message provided...');
			}

			if (!schemeRef) {
				throw new Error('No Building reference provided...');
			}
			url = url.replace('{schemeRef}', schemeRef).trim();
			url = url.replace('{approvalId}', approvalId).trim();
			
			const docload = {
				Message: message
			};

			const results = await this.$http.post(url, docload);
			const { data } = results;

			await this.getDocumentApprovals(schemeRef);

			this.$timeout(() => promiseHandler.resolve(data));
		} catch (error) {
			this.$timeout(() => promiseHandler.reject(error));
		}

		return promise;
	}
}

export default /* @ngInject */ (
	$http,
	Utility,
	$timeout,
	$rootScope,
	ContentService,
	LocalStorageService,
	InternalLinksService
) =>
	new ApprovalDocumentsDataService(
		$http,
		Utility,
		$timeout,
		$rootScope,
		ContentService,
		LocalStorageService,
		InternalLinksService
	);
